import Vue from "vue";
import HotelComponent from "./components/HotelComponent";


Vue.prototype.$baseUrl = document.head.querySelector(
    'meta[name="base-url"]'
).content;

const app = new Vue({
    data() {
        return {
            availableHotelsLabel: null,
        };
    },
    components: {
        HotelComponent,
    },
    methods: {
        updateAvailableHotelsLabel(event) {

            if (event.paginateResults) {
                this.availableHotelsLabel = `${event.hotels} hotels shown`
                return;
            }

            const percent = event.progress;
            this.availableHotelsLabel = percent < 100
                ? `${event.hotels} hotels found (... ${percent}%)`
                : `${event.hotels} hotels found`;
        },
    },
    updated: function () {
        var ww = document.body.clientWidth;
        $(".closebtn").show();

        if (ww < 990) {
            $(".closebtn").show();
            $(".hotellist").removeClass("col-md-9");
            $(".hotellist").addClass("col-md-12");
            $(".search_opt_col").addClass("filter_by_small");
            if ($(".register-banner").is(":visible")) {
                $(".register-content").hide();
            } else {
                $(".register-content").show();
            }

            $(".sign-up-video-button").show();
        } else if (ww >= 990) {
            $(".hotellist").removeClass("col-md-12");
            $(".hotellist").addClass("col-md-9");
            $(".search_opt_col").removeClass("filter_by_small");
            $(".search_opt_col").removeAttr("style");

            if ($(".register-banner").is(":visible")) {
                $(".register-content").show();
            }

            $(".sign-up-video-button").hide();

            $(".register-banner").show();
        }
        $('.closebtn').click(function () {
            $('.filter_by_small').width('0px');
            $('.filter_by_small').css('left', -100);
            $('.menu_by_small').width('0');
            $('.menu_by_small').css('left', -50);
        });
    },
});

app.$mount("#vueApp");
